// src/components/common/DownloadProgress.jsx
import React from 'react';
import { Download, CheckCircle, AlertCircle, FileText, Archive, X } from 'lucide-react';

const DownloadProgress = ({ 
    isDownloading, 
    downloadType, 
    progress = 0, 
    error = null,
    onClose,
    success = false
}) => {
    if (!isDownloading && !error && !success) return null;

    const getIcon = () => {
        if (error) return <AlertCircle className="h-6 w-6 text-red-500" />;
        if (success) return <CheckCircle className="h-6 w-6 text-green-500" />;
        if (downloadType === 'pdf') return <FileText className="h-6 w-6 text-blue-500" />;
        if (downloadType === 'zip') return <Archive className="h-6 w-6 text-purple-500" />;
        return <Download className="h-6 w-6 text-blue-500" />;
    };

    const getMessage = () => {
        if (error) return `Error: ${error}`;
        if (success) return 'Descarga completada exitosamente';
        if (downloadType === 'pdf') return 'Generando PDF con códigos QR...';
        if (downloadType === 'zip') return 'Creando archivo ZIP...';
        return 'Descargando...';
    };

    const getBgColor = () => {
        if (error) return 'bg-red-50 border-red-200';
        if (success) return 'bg-green-50 border-green-200';
        return 'bg-blue-50 border-blue-200';
    };

    return (
        <div className="fixed top-4 right-4 z-50">
            <div className={`${getBgColor()} border rounded-lg p-4 shadow-lg max-w-sm`}>
                <div className="flex items-start space-x-3">
                    <div className="flex-shrink-0">
                        {getIcon()}
                    </div>
                    
                    <div className="flex-1 min-w-0">
                        <div className="flex items-center justify-between">
                            <p className="text-sm font-medium text-gray-900">
                                {getMessage()}
                            </p>
                            {onClose && (
                                <button
                                    onClick={onClose}
                                    className="ml-2 text-gray-400 hover:text-gray-600"
                                >
                                    <X className="h-4 w-4" />
                                </button>
                            )}
                        </div>
                        
                        {isDownloading && !error && (
                            <div className="mt-2">
                                <div className="w-full bg-gray-200 rounded-full h-2">
                                    <div 
                                        className="bg-blue-600 h-2 rounded-full transition-all duration-300"
                                        style={{ width: `${Math.min(progress, 100)}%` }}
                                    ></div>
                                </div>
                                <p className="text-xs text-gray-500 mt-1">
                                    {Math.round(progress)}% completado
                                </p>
                            </div>
                        )}
                        
                        {success && (
                            <p className="text-xs text-green-600 mt-1">
                                El archivo se ha descargado correctamente
                            </p>
                        )}
                        
                        {error && (
                            <p className="text-xs text-red-600 mt-1">
                                Intenta nuevamente o contacta soporte
                            </p>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DownloadProgress;